import React from "react";
import { FaLinkedin, FaGithub, FaInstagram } from "react-icons/fa";
import { FaSquareUpwork } from "react-icons/fa6";
import { RiTwitterXLine } from "react-icons/ri";


const Footer = () => {
  return (
    <footer className="relative bg-neutral-900 border-t-2 border-[#7C6AE6] px-6 py-[50px]">
      <div className="mx-auto max-w-[1200px] space-y-16">

        {/* TOP CTA */}
        <div className="text-center md:text-left">
          <p className="text-base md:text-lg text-neutral-200">
            Have an idea or a project in mind?
          </p>

          <a
            href="mailto:buildwithpelumi@gmail.com"
            className="mt-2 inline-block text-[#7C6AE6] text-2xl sm:text-3xl md:text-4xl font-medium tracking-tight hover:opacity-80 transition"
          >
            buildwithpelumi@gmail.com
          </a>
        </div>

        {/* MAIN CARD */}
        <div className="bg-[#7C6AE6] rounded-[14px] px-6 py-8 md:px-10 md:py-10 text-white">
          <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">

            {/* IDENTITY */}
            <div className="max-w-md">
              <h3 className="text-2xl font-semibold">
                pelumi.
              </h3>

              <p className="mt-1 text-sm md:text-base font-medium opacity-90">
                Front-end & WordPress Developer
              </p>

              <p className="mt-3 text-sm opacity-80 leading-relaxed">
                I design and build fast, maintainable websites with clarity,
                performance, and long-term value in mind.
              </p>
            </div>

            {/* SOCIALS */}
            <div className="flex items-center gap-5">
            
              <a
                href="https://www.linkedin.com/in/pelumi-atoyebi-192a9331b/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="hover:opacity-80 transition"
              >
                <FaLinkedin size={26} />
              </a>

                <a
                href="https://www.upwork.com/freelancers/~01e6f715abb88ac10c"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="hover:opacity-80 transition"
              >
                <FaSquareUpwork size={26} />
              </a>

              <a
                href="https://github.com/heispelumi"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="hover:opacity-80 transition"
              >
                <FaGithub size={26} />
              </a>

              <a
                href="https://x.com/heispelumi_"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter / X"
                className="hover:opacity-80 transition"
              >
                <RiTwitterXLine size={26} />
              </a>

              <a
                href="https://www.instagram.com/buildwithpelumi/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="hover:opacity-80 transition"
              >
                <FaInstagram size={26} />
              </a>

            

            </div>
          </div>
        </div>

        {/* BOTTOM META */}
        <div className="flex flex-col gap-3 text-center md:flex-row md:justify-between text-sm text-neutral-400">
          <p>© {new Date().getFullYear()} Pelumi. All rights reserved.</p>
          <p>Built with care and attention to detail.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
